import 'bootstrap/dist/css/bootstrap.min.css';
import "../header/style.css"
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const Headersite = styled.header`
    padding: 30px 0;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 999;
`

const BtnHome = styled.div`
    color: #fff;
    
    & a{
        color: #fff;
        font-size: 18px;
        transition: 0.3s linear;
    }

    & a:hover{
        color: #CD0FE8;
    }
`

const NavMenu = styled.nav`
    color: #fff;
    & ul{
        list-style: none;
        padding: 0;
    }

    & ul li a{
        color: #fff;
        text-decoration: none;
        width: 80%;
        display: inline-block;
        padding: 5px 0;
        transition: 0.4s linear;
        margin: 5px 0;
    }

    & ul li a:hover{
        color: #8c079eff;
    }

    & ul li{
        counter-increment: items;

    }

    & li:before {
        content: "0" counter(items)". ";
    }

    .& li:nth-child(n+10):before {
        content: "0" counter(items)". ";
    }

    .& li:nth-child(n+100):before {
        content: counter(items)". ";
    }

`

export const Bigmenu = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background-color: #111; /* cor de fundo do menu */
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    z-index: 999;
    padding: 2rem;

    &.open {
        transform: translateX(0);
    }

    @media(min-width: 996px){
        width: 320px;
    }
    @media(min-width: 1440px){
        width: 400px;
    }
`;

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  return (
    <Headersite>
      <div className='container'>
        <div className='row'>
          <div className='col-6'>
            <BtnHome>
              <Link to="/" style={{ textDecoration: 'none' }}>
                <span className="typewriter-text">barbxsa.dev</span>
              </Link>
            </BtnHome> 
          </div>
          <div className='col-6 text-lg-end'>
            <div className='align-items-center d-flex gap-2 justify-content-end menu'>
              <span>Menu</span>
              <button id="menu" aria-label='Menu' onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <Bigmenu className={menuOpen ? 'open' : ''}>
            <div className='flex-menu'>
                <div className='topo_menu'>
                    <div className='first_top'>
                        <button id='close' onClick={toggleMenu}>
                            &#10060;
                            <span>Fechar</span>
                        </button>
                    </div>
                    <div className='brand__menu'>
                        <a href='curriculo2025.pdf' target='_blank' style={{ textDecoration: 'none' }}>
                            <div className='logo_brand'>
                                <img src="ico.svg" alt="Logo Gabriel Barbosa"></img>
                            </div>
                            <span>barbxsa.dev</span>
                        </a>
                    </div>
                </div>
                <div className='mid_menu'>
                    <NavMenu>
                        <ul>
                            <div className='d-flex gap-4 justify-content-lg-between'>
                                <h4>Projetos</h4>
                                <hr style={{ width: '75%' }}></hr>
                            </div>
                            <li><Link to="/fcopel" style={{ textDecoration: 'none' }} onClick={toggleMenu}>Fundação Copel </Link></li>
                            <li><Link to="/energisaprev" style={{ textDecoration: 'none' }} onClick={toggleMenu}>EnergisaPrev </Link></li>
                            <li><Link to="/elosprev" style={{ textDecoration: 'none' }} onClick={toggleMenu}>Elos Previdência </Link></li>
                            <li><Link to="/prestador" style={{ textDecoration: 'none' }} onClick={toggleMenu}>Prestador da Copel</Link></li>
                            <li><Link to="/fundaffemg" style={{ textDecoration: 'none' }} onClick={toggleMenu}>Fundaffemg</Link></li>
                            <li><Link to="/sharknarguiles" style={{ textDecoration: 'none' }} onClick={toggleMenu}>Shark Narguiles</Link></li>
                        </ul>
                    </NavMenu>
                </div>
                <div className='bottom_menu'>
                    <ul>
                        <li><a href="https://github.com/barbxsa" target='_blank'>GitHub</a></li>
                        <li><a href="https://www.linkedin.com/in/barbxsa/" target='_blank'>Linkedin</a></li>
                        <li><a href="https://api.whatsapp.com/send?phone=5511994246251" target='_blank'>Contato</a></li>
                    </ul>
                </div>
            </div>
      </Bigmenu>
    </Headersite>
  );
}

export default Header